import { useTranslation } from 'react-i18next';

import { NavItem, Section } from '../../Common/Layout';
import { RegistrationSummary } from '../helpers';
import { useNavigation } from '../../Common/useNavigation';
import SupportaSymbol from '../../../common/Common/SupportaSymbol';
import UI from '../../../common/UI';
import useProject from '../../useProject';

export interface CompanyFundraisingSectionProps {
  summary: RegistrationSummary;
}

const CompanyFundraisingSection = ({
  summary,
}: CompanyFundraisingSectionProps) => {
  const { t } = useTranslation();
  const { r } = useNavigation();
  const project = useProject();

  const { charity } = summary.event_participant;

  return (
    <Section title={t('fundraising')}>
      <NavItem
        to={r('Charity', {
          projectId: project.id,
          participantId: summary.participant.id,
          eventId: summary.event.id,
          token: summary.view_token,
        })}
        alignVertical="center"
      >
        <UI.GridContainer sc={{ columns: '40px 1fr', alignVertical: 'center', gutter: 0.5 }}>
          <UI.ProfilePic
            sc={{
              size: 40,
              background: !charity?.logo_url ? 'supporta_emerald' : 'white',
              color: 'white',
            }}
          >

            {charity?.logo_url ? (
              <img src={charity.logo_url} alt={charity.title} />
            ) : (
              <UI.Icon sc={{ size: 1.5 }}>
                <SupportaSymbol />
              </UI.Icon>
            )}
          </UI.ProfilePic>
          <UI.Div>
            <UI.H4>
              {charity ? t('edit_charity') : t('set_up_fundraising')}
            </UI.H4>
            {charity ? charity.title : t('set_up_fundraising_description')}
          </UI.Div>
        </UI.GridContainer>
      </NavItem>
    </Section>
  );
};

export default CompanyFundraisingSection;
